import React, { useEffect, useState } from 'react';
import { toFlag } from 'pano-utils';
import { HSIconType } from '@types';
import { Collapse } from '@components/Collapse';
import Button from '@components/Button';
import { $editingHotspotApi } from '@stores/editingHotspotStores';
import FeatureToggle from '@components/FeatureToggle';
import { $playerWidgetsApi } from '@stores/playerWidgets';
import { type DropdownItem, Dropdown } from '@components/Dropdown';
import { reAddEditingHotspot } from '@modules/hotspot/actions';

interface Props {
  iconType: HSIconType | 'none';
  onChange: (customStyle: boolean) => void;
}

const items: DropdownItem<boolean>[] = [
  { id: false, name: '保持原有样式' },
  { id: true, name: '自定义样式' },
];

function TitleBatchSetting({ iconType, onChange }: Props) {
  const [customStyle, setCustomStyle] = useState(false);
  const [showTitle, setShowTitle] = useState(true);

  useEffect(() => {
    return () => {
      $playerWidgetsApi.remove('title');
    };
  }, []);

  useEffect(() => {
    if (!customStyle || !showTitle) {
      $playerWidgetsApi.remove('title');
    }
  }, [customStyle, showTitle]);

  useEffect(() => {
    if (customStyle) {
      reAddEditingHotspot();
    }
  }, [customStyle]);

  const handleTitleToggle = (isOn: boolean) => {
    setShowTitle(isOn);
    $editingHotspotApi.update((draft) => {
      draft.showTitle = toFlag(isOn);
    });
  };

  return (
    <Collapse title="标题设置">
      <Dropdown
        items={items}
        className="mb-20"
        selected={customStyle}
        placeholder={items[0].name}
        onChange={(id) => {
          setCustomStyle(id);
          onChange(id);
        }}
      />
      {!customStyle && (
        <div className="mt-10 text-orange">
          提示：
          <br />
          1.选择并完成设置后所有所选热点的图标特 同步修改为对应图标
          <br />
          2.不支持批量修改为多边形
        </div>
      )}
      {iconType !== HSIconType.mark && customStyle && (
        <FeatureToggle
          title="显示标题"
          className="mt-20"
          isOn={showTitle}
          onToggle={handleTitleToggle}
        />
      )}
      {customStyle && showTitle && (
        <Button
          className="mt-20 w-full"
          onClick={() => $playerWidgetsApi.add('title')}
        >
          标题高级设置
        </Button>
      )}
    </Collapse>
  );
}

export default TitleBatchSetting;
